export const ASSO = {
  name: "Cœur d'École Toury Famille",
  shortName: "CETF",
  fullName: "Cœur d'École Toury Famille — Association (CETF)",
  description:
    "Association loi 1901 à Toury. Nous organisons des activités socio-éducatives et socio-culturelles, des manifestations conviviales et solidaires auprès des enfants et des familles, et nous veillons à la défense des intérêts moraux ainsi que des droits des enfants et des familles.",
  email: "cetf.asso@gmail.com",
  president: "Teddy Idmont",
  helloassoUrl:
    "https://www.helloasso.com/associations/coeur-d-ecole-toury-famille-association-cetf",
  helloassoDonateUrl:
    "https://www.helloasso.com/associations/coeur-d-ecole-toury-famille-association-cetf/formulaires/1",
  logoUrl:
    "https://cdn.helloasso.com/img/logos/croppedimage-d692260700944754aaf358f15217fb38.png?width=140&height=140&img_format=webp&quality=80&resize=fill",
  logoTreeUrl: "/assets/logo-tree.png",
  logoFullUrl: "/assets/logo-full.png",
  socials: {
    facebook: "https://www.facebook.com/share/1CCeeCEEyT/",
    instagram: "https://www.instagram.com/cetfassociation28",
    tiktok: "https://www.tiktok.com/@cetfassociation28",
    snapchat: "https://www.snapchat.com/add/cetfassociation",
  },
  heroImage:
    "https://images.pexels.com/photos/8033860/pexels-photo-8033860.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  communityImage:
    "https://images.pexels.com/photos/31874024/pexels-photo-31874024.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  festiveImage:
    "https://images.unsplash.com/photo-1777881739588-bf530a4ae427?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxwYXJlbnRzJTIwY2hpbGRyZW4lMjBzY2hvb2wlMjBldmVudCUyMEZyZW5jaCUyMGNvbW11bml0eXxlbnwwfHx8fDE3ODk3NjM5MTV8MA&ixlib=rb-4.1.0&q=85",
};

export const MEETING_TYPES = ["Conseil d'école", "Conseil de classe", "Réunion de bureau", "Assemblée générale", "Autre"];

export const TREASURY_CATEGORIES = ["Cotisations", "Dons", "Subventions", "Événements", "Fournitures", "Fonctionnement", "Autre"];

export const PERMISSIONS = [
  { key: "evenements", label: "Événements" },
  { key: "membres", label: "Adhérents" },
  { key: "benevoles", label: "Bénévoles" },
  { key: "contenus", label: "Contenus / actualités" },
  { key: "documents", label: "Documents & PV" },
  { key: "tresorerie", label: "Trésorerie" },
  { key: "participations", label: "Participations" },
  { key: "messages", label: "Messages" },
  { key: "journal", label: "Journal d'activité" },
  { key: "liste_cetf", label: "Liste CETF" },
  { key: "store", label: "CETF Store" },
];

export const COTISATION_LABELS = {
  a_jour: "À jour",
  en_attente: "En attente",
  expiree: "Expirée",
};

export const BUREAU_ROLES = {
  "": "—",
  president: "Président·e",
  vice_president: "Vice-président",
  vice_presidente: "Vice-présidente",
  tresorier: "Trésorier·ère",
  secretaire: "Secrétaire",
  membre_bureau: "Membre du bureau",
};

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export function displayEventDate(iso) {
  if (!iso) return "";
  if (iso.includes("T00:00:00")) return formatDate(iso);
  return formatDateTime(iso);
}

const GREETING_TITLES = {
  president: "Monsieur le Président",
  presidente: "Madame la Présidente",
  vice_president: "Monsieur le Vice-président",
  vice_presidente: "Madame la Vice-présidente",
};

export function greetingFor(user) {
  const title = GREETING_TITLES[user?.bureau_role];
  if (title) return `Bonjour ${title}`;
  return `Bonjour ${user?.first_name || ""}`.trim();
}
